module.exports = __webpack_public_path__ + "img/dialog1-btn-diamond.e1650771.png";